export default __webpack_public_path__ + "static/24_months-b6c3ea65521e52a7b6451c966de5ef8c.jpeg";